<template>
	<v-col cols="12" class="text-left pa-1">
		<div v-if="!selectedApp">
			<h2 class="med">Choose app</h2>
			<v-autocomplete
				ref="searchApp"
				hide-details
				single-line
				:menu-props="menuProps"
				:search-input.sync="searchString"
				:items="appItems"
				item-text="service_name"
				item-value="id"
				color="#5C8DF5"
				height="52"
				class="ac my-4"
				outlined
				label="Search for an app"
			>
				<template v-slot:prepend-inner>
					<div class="mx-2 s_ic">
						<SIcon name="autocomplete-search" />
					</div>
				</template>
				<template v-slot:append>
					<span></span>
				</template>
			</v-autocomplete>
			<v-row no-gutters v-if="filteredItems.length > 0">
				<v-col
					cols="6"
					role="button"
					v-for="item in filteredItems"
					:key="item.id"
					class="py-5 result_block text-center"
					@click="$emit('setSelectedApp', item)"
				>
					<v-row no-gutters class="">
						<v-col class="text-center" cols="12">
							<v-card class="ac_card inline-block ma-0 pa-0">
								<div class="centerdXY">
									<SIcon :width="22" :name="item.service_slug" />
								</div>
							</v-card>
						</v-col>
						<v-col class="text-center" cols="12">
							<h3 class="reg inline-block">{{ item.service_name }}</h3>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</div>
		<div v-else>
			<v-row no-gutters class="choose_item_type">
				<v-col cols="12">
					<v-row no-gutters class="align-center">
						<v-col cols="7" class="text-left">
							<v-row align="center">
								<v-col cols="auto">
									<div class="ac_card inline-block ma-0 pa-0">
										<div class="centerdXY">
											<SIcon :width="16" :name="selectedApp.service_slug" />
										</div>
									</div>
								</v-col>
								<v-col>
									<h3 class="reg inline-block pl-6" style="vertical-align: middle">
										<span>{{ selectedApp.service_name }}</span> <br />
									</h3>
								</v-col>
							</v-row>
						</v-col>
						<v-col class="text-right" cols="5">
							<v-btn rounded outlined color="#D1D9E9" class="chg" height="30px" @click="$emit('changeActionOrService')">Change</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
export default {
	name: 'ServiceSelector',
	components: {},
	props: {
		selectedApp: { type: Object },
		menuProps: { type: Object },
		appItems: { type: Array },
	},
	computed: {
		filteredItems() {
			if (this.searchString == '') {
				return this.appItems;
			} else {
				return this.$refs.searchApp.filteredItems;
			}
		},
	},
	watch: {
		searchString: {
			handler(newV) {
				this.$emit('setSearchString', newV);
			},
		},
	},
	data: () => ({
		searchString: '',
	}),
};
</script>

<style scoped lang="scss">
::v-deep .step-select-container {
	display: flex;
	align-items: center;
	max-width: 100%;

	> div {
		margin: 0 10px 0 0;
	}
}
</style>
